import { Box, Typography, LinearProgress, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const SLAProgress = ({ sla, remainingDays }) => {
  const theme = useTheme();
  const actualRemaining = remainingDays < 0 ? 0 : remainingDays;
  const breachedDays = remainingDays < 0 ? Math.abs(remainingDays) : 0;

  const progress = ((sla - actualRemaining) / sla) * 100;
  const getProgressColor = (daysLeft, totalSLA) => {
    const ratio = (daysLeft / totalSLA) * 100;
    if (ratio >= 60) return theme.palette.success.main; // >= 60% time left
    if (ratio >= 30 && ratio < 60) return theme.palette.warning.light; // 30–59% time left
    return theme.palette.error.main; // < 30% time left
  };

  const progressColor = getProgressColor(actualRemaining, sla);

  return (
    <Box sx={{ width: "200px", textAlign: "center" }}>
      {/* Header with SLA and Remaining Days */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontWeight: 500,
          }}
        >
          SLA: {sla}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: progressColor,
          }}
        >
          Remaining: {actualRemaining}
        </Typography>
      </Box>

      {/* Linear Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: theme.shape.borderRadius,
          backgroundColor: theme.palette.grey[200],
          "& .MuiLinearProgress-bar": {
            backgroundColor: progressColor,
            borderRadius: theme.shape.borderRadius,
          },
        }}
      />
      {breachedDays > 0 && (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.error.main, display: "flex", mt: 1 }}
        >
          SLA Breached: {breachedDays} day{breachedDays > 1 ? "s" : ""}
        </Typography>
      )}
    </Box>
  );
};

SLAProgress.propTypes = {
  sla: PropTypes.number.isRequired,
  remainingDays: PropTypes.number.isRequired,
};

export default SLAProgress;